<template>
    <header
        class="sticky top-0 z-10 flex max-h-[118px] min-h-[118px] flex-col items-center justify-between border-b bg-white px-4 pb-2 pt-2 lg:max-h-[136px] lg:min-h-[136px] lg:py-6"
    >
        <div
            class="container mx-auto flex h-full w-full justify-between px-0 lg:px-12"
        >
            <div class="lg:flex lg:flex-col lg:gap-8">
                <a href="/" class="hidden lg:flex">
                    <v-icon icon="n24-beta"></v-icon>
                </a>
                <a
                    :href="routes.previousStep ? routes.previousStep : '/'"
                    class="flex cursor-pointer items-center space-x-2 rounded-full px-4 py-3 text-form text-black-78 hover:bg-green-10"
                >
                    <v-icon icon="back" size="5"></v-icon>
                    <span>Nazaj</span>
                </a>
            </div>
            <v-add-listing-stepper
                :step="step"
                class="-mx-4 self-end max-lg:pb-3 max-md:absolute max-md:bottom-2 max-md:px-4"
            ></v-add-listing-stepper>
            <div>
                <a
                    class="flex items-center space-x-2 rounded-full px-4 py-3 text-form text-black-78 hover:bg-green-10"
                    href="/"
                >
                    <v-icon icon="close" size="5"></v-icon>
                    <span>Zapri</span>
                </a>
            </div>
        </div>
    </header>
</template>

<script>
import AddListingStepper from "./AddListingStepper.vue";

export default {
    components: {
        "v-add-listing-stepper": AddListingStepper,
    },
    props: {
        routes: {
            type: Object,
            required: true,
        },
        step: {
            type: Number,
            default: 0,
        },
    },
    methods: {},
};
</script>
